import React from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';

import SignContractModal from 'components/common/modals/SignContractModal';
import { LayoutCabinet } from 'layouts';

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isSignContractOpen = searchParams.has('sign-contract');

  const closeSignContract = () => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('sign-contract');
    setSearchParams(nextParams, { replace: true });
  };

  return (
    <LayoutCabinet>
      <Outlet />
      {isSignContractOpen ? <SignContractModal onClose={closeSignContract} /> : null}
    </LayoutCabinet>
  );
};

export default Dashboard;
